var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParticletwo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 198,
    viewBox: "0 0 112 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.78,
    width: 9.94394,
    height: 9.94394,
    transform: "matrix(0.990268 -0.139173 -0.139173 -0.990268 72.0001 12)",
    fill: "#C44536",
    fillOpacity: 0.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.91,
    width: 10.9285,
    height: 10.9285,
    transform: "matrix(-0.743145 -0.669131 -0.669131 0.743145 15.6667 32)",
    fill: "#C44536",
    fillOpacity: 0.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.98,
    width: 6.69493,
    height: 6.69493,
    transform: "matrix(-0.0697566 0.997564 0.997564 0.0697566 105 107.333)",
    fill: "#C44536",
    fillOpacity: 0.7
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.87,
    width: 8.17175,
    height: 8.17175,
    transform: "matrix(-0.104529 0.994522 0.994522 0.104529 20.6667 157.333)",
    fill: "#C44536",
    fillOpacity: 0.7
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.73,
    width: 6.20266,
    height: 6.20266,
    transform: "matrix(0.999848 0.0174526 0.0174526 -0.999848 102 197.667)",
    fill: "#C44536",
    fillOpacity: 0.7
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.98,
    width: 10.9285,
    height: 10.9285,
    transform: "matrix(0.438371 -0.898794 -0.898794 -0.438371 41.6667 196.667)",
    fill: "#C44536",
    fillOpacity: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticletwo);
export default __webpack_public_path__ + "static/media/particletwo.510c1736110a16c83320b344aa6194c7.svg";
export { ForwardRef as ReactComponent };